import { TLink } from '../../types/links';

export const LINKS_ORDER_DEFAULT: TLink[] = [
  'help',
  'legalDocuments',
  'price',
  'contacts',
  'advert',
  'fairplay',
  'promo',
  'auction',
  'searchOnMap',
  'tv',
  'vacancies',
  'mortgageCalculator',
  'legalCheck',
  'sitemap',
  'newOffers',
  'career',
];
